import { styled, StepProps as MuiStepProps, Step as MuiStep } from "@mui/material";

export interface StepProps extends MuiStepProps {
  stepIds?: string;
}

export const Step = styled(({ stepIds, ...props }: StepProps) => (
  <MuiStep {...props} {...(stepIds ? a11yProps(stepIds, props.index) : {})} />
))({});

function a11yProps(stepIds: string, value: unknown) {
  return {
    id: `${stepIds}-step-${value}`,
    'aria-controls': `${stepIds}-steplabel-${value}`,
  };
}
